<template>
  <div class="container">
    <div class="stepper">
      <div
        v-for="(step, index) in steps.stepMap"
        :key="step.label"
        class="stepper-step"
        :class="{lastStep: isLastItem(index)}">
        <div
          class="stepper-step-index"
          :class="{
            done: isDone(step.startIndex),
            current: isCurrent(step.startIndex, index)
          }">
          <span v-if="isDone(step.startIndex) && !isCurrent(step.startIndex, index)">
            <i class="material-icons">check</i>
          </span>
          <span v-else>{{index + 1}}</span>
        </div>
        <div
          v-if="isQuestionsSection(index)"
          class="stepper-step-label">
          <div class="stepper-step-label-title">{{step.label}}</div>
          <div class="stepper-step-label-subtitle">{{questionStepLabel}}</div>
        </div>
        <div
          v-else
          class="stepper-step-label">
          <div class="stepper-step-label-title">{{step.label}}</div>
          <div class="stepper-step-label-subtitle">{{step.subtitle}}</div>
        </div>
        <span
          class="divider"
          v-if="!isLastItem(index)" />
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  name: 'Stepper',
  computed: {
    ...mapGetters({
      meeting: 'meeting/meeting',
      steps: 'steps',
      questions: 'questions/questions'
    }),
    totalSteps() {
      return this.steps.pathing.length - 1;
    },
    totalQuestions() {
      return this.questions.length;
    },
    questionStepLabel() {
      let maxQuestions = this.steps.stepMap[2].startIndex - this.steps.stepMap[1].startIndex;
      let currentQuestion = this.steps.current;

      if (currentQuestion > maxQuestions || currentQuestion === -1) {
        currentQuestion = maxQuestions;
      }
      return `${currentQuestion} / ${maxQuestions}`;
    }
  },
  methods: {
    isLastItem(index) {
      return index === this.steps.stepMap.length - 1;
    },
    isCurrent(startIndex, index) {
      const currentStep = this.steps.current;
      const lastStepObj = this.steps.stepMap[this.steps.stepMap.length - 1];

      if (startIndex === 0) {
        return currentStep === startIndex;
      } else if (startIndex > 0 && startIndex < lastStepObj.startIndex) {
        return currentStep >= startIndex &&
               currentStep < this.steps.stepMap[index+1].startIndex;
      } else {
        return currentStep >= startIndex;
      }
    },
    isDone(startIndex) {
      return (this.steps.current > startIndex);
    },
    isQuestionsSection(index) {
      // This is the actual index of stepMap
      // Works only because index 1 is Questions
      return (index === 1);
    }
  },
  data() {
    return {};
  }
};
</script>

<style scoped>
.container {
  display:flex;
  justify-content: center;
}
.stepper {
  height: 100px;
  display: flex;
  width: 100%;
  max-width: 850px;
}
.stepper-step {
  display: flex;
  align-items: center;
  width: 100%;
  margin-right: 10px;
}
.stepper-step.lastStep {
  width: 100px;
}
div.stepper-step span.divider {
  width: 100%;
  flex-shrink: 1;
  border-bottom: 1px solid #757575;
  opacity: .35;
}
.stepper-step-label {
  overflow: visible;
  margin-right: 10px;
}
.stepper-step-label-title {
  font-weight: bold;
  font-size: 16px;
}
.stepper-step-label-subtitle {
  color: #757575;
  font-weight: 100;
  font-size: 14px;
}
.stepper-step-index {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  min-width: 38px;
  min-height: 38px;
  background-color: #E0E0E0;
  margin-right: 8px;
  border-radius: 50%;
}
.stepper-step-index.done {
  background-color: #9FA8DA;
  color: #FFFFFF;
}
.stepper-step-index.current {
  background-color: #3F51B5;
  color: #FFFFFF;
}

@media only screen and (max-width: 450px) {
  .container {
    display: none;
  }
}
</style>
